// src/helpers/currencyOptions.js

const currencyOptions = {
  number: {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    numeralDecimalScale: 0,
    numeralPositiveOnly: true,
  },
  // Kamu bisa nambah preset lain juga di sini
  priceWithDecimal: {
    numeral: true,
    numeralDecimalScale: 2,
    numeralThousandsGroupStyle: 'thousand',
    prefix: 'Rp ',
    stripLeadingZeroes: true,
  },
}

export default currencyOptions
